import { render, staticRenderFns } from "./ShowAvatar.vue?vue&type=template&id=46d3b15a&"
import script from "./ShowAvatar.vue?vue&type=script&lang=js&"
export * from "./ShowAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports